<template>
    <el-dialog
            class="more-box"
            :visible.sync="dialogVisible"
            :before-close="handleClose"
            :append-to-body="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="isWordAudio?'音频配置':'素材库'"
            :width="isWordAudio?'1106px':'1170px'">
        <Material
            v-if="visible"
            ref="material"
            :isCocos="newIsCocos"
            :isAuto="isAuto"
            :isEdit="isEdit"
            :curEditItem="curEditItem"
            :value.sync="htmlContent"
            :newCategoryId.sync="categoryId"
            :type.sync="newType"
            :search.sync="search"
            :filterValue.sync="newFilterValue"
            :catalog.sync="newCatalog"
            :callBack.sync="callBack"
            :navId.sync="navId"
            :isWordAudio.sync="isWordAudio"
            :selfFlag.sync="selfFlag"
            :activeIndex.sync="activeIndex"
            @onSelect="onSelect"
            @success="handleClose"
        />
        <div class="search" v-if="['0', '1'].includes(`${$enums.enumTypeName[activeIndex]}`)">
            <div class="select-box">
                <el-select
                        v-if="['game', 'tools'].includes(type)"
                        class="filter-box"
                        v-model="newFilterValue"
                        placeholder="请选择"
                        size="small"
                        :filterable="true"
                        @change="handleClickChangeFilter(newFilterValue)"
                        @clear="handlerClear"
                >
                    <el-option
                            v-for="item in filterOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-input
                placeholder="输入搜索名称"
                v-model="searchValue"
                prefix-icon="el-icon-search"
                size="small"
                autofocus
            ></el-input>
        </div>
    </el-dialog>
</template>

<script>
    import Material from '../../../../../../components/Material'

    export default {
        name: 'more',
        components: {
            Material,
        },
        props: {
            isCocos: {
                type: Boolean,
                default: false
            },
            isAuto: {
                type: Boolean,
                default: true
            },
            isEdit: {
                type: Boolean,
                default: false,
            },
            curEditItem: Object,
            visible: {
                type: Boolean,
                default: false,
            },
            categoryId: [String,Number],
            type: String,
            // 当前选中的目录
            catalog: [String, Number],
            // 回调信息
            callBack: Object,
            // 导航id
            navId: [String, Number],
            // 文音组件
            isWordAudio: {
                type: Boolean,
                default: false
            },
            // 自定义配置
            selfFlag: Object,
        },
        computed: {
            filterOptions(){
                
                let typeData=[];
                if(this.practiceBool()){
                    typeData=[
                        {value: 'is_exercise', label: '课后练习'}
                    ];
                }else{
                    typeData=[
                            {value: '', label: '全部'},
                            {value: 'is_online', label: '线上直播'},
                            {value: 'is_offline', label: '线下白板'},
                            {value: 'is_double_teacher', label: '线下答题器'},
                        ];
                }
                return typeData;
            },
        },
        watch: {
            isCocos(vl) {this.newIsCocos = vl;},
            newIsCocos(vl) {this.$emit('update:isCocos', vl);},
            visible(vl) {this.dialogVisible = vl;},
            dialogVisible(vl) {this.$emit('update:visible', vl);},
            type(vl) {this.newType = vl;},
            categoryId(vl) {this.categoryId = vl;},
            newType(vl) {this.$emit('update:type', vl);},
            catalog(vl) {this.newCatalog = vl;},
            newCatalog(vl) {this.$emit('update:catalog', vl);},
            searchValue() {
                clearTimeout(this.searchFn)
                this.searchFn = setTimeout(()=>{
                    this.onSearch()
                },300)
            }
        },
        data() {
            return {
                newFilterValue: '',
                activeIndex: '',
                newIsCocos: this.isCocos, // 是否是cocos发来的消息
                newCatalog: this.catalog, // 当前选中的目录-(用于场景选择)
                searchValue: '',
                search: '', // 搜索
                dialogVisible: this.visible,
                htmlContent: '', // 富文本内容
                newType: this.type,
                searchFn: null // 搜索计时器
            };
        },
        created(){
            if(this.practiceBool()){
                this.newFilterValue='is_exercise';
            }
        },
        methods: {
            practiceBool(){
                return `${this.$route.query.is_practice}` === 'true'
            },
            // 选中
            onSelect(item){
                this.$emit('onSelect', item)
            },
            onSearch(){
                this.search = this.searchValue
                console.log('搜索==>', this.search)
            },
            // 获取搜索数据
            async getSearchData({perPage}) {
              let list = []
                this.isLoading = true
                try {
                  let obj = {perPage, page: 1, is_online: this.isPlat?1:0, is_push: this.isPlat?1:0}
                  let getList = this.getResourceList
                  let data = null
                  // if (this.selectCatalog)
                  obj.categoryId = this.selectCatalog
                  if (this.search) obj.search = this.search

                  let newObj = this.getCurObj(obj)
                  console.log("开始搜索数据：",newObj);

                  if(this.type === 'game')getList = 'getGameList'
                  data = await commonServer.default[getList](newObj)

                  if(this.type === 'game') {
                      // 游戏搜索，必须关联出所有场景
                      let newArr = []
                      let sesScene
                      let arr = data.items
                      for(let i = 0, len = arr.length; i < len; i++) {
                          /*sesScene = await commonServer.default[this.getFormList]({
                              page: 1,
                              categoryId: arr[i].form_category_id_scenes,
                              perPage: 6
                          })*/
                          sesScene=arr[i].form_category_scenes_list;
                          //sesScene.items.map(q=>{
                          sesScene.map(q=>{
                              newArr.push({
                                  ...arr[i],
                                  form_id_scenes: q.id,
                                  alias: `${arr[i].alias}-${q.name}`,
                                  url: this.getImg(q.options)
                              })
                          })
                          this.searchLastPage = data.meta.last_page
                      }
                      list = newArr
                  } else {
                      this.searchLastPage = data.meta.last_page
                      list = this.getResultData(data.items)
                  }
                }catch (e) {
                    console.log('获取搜索数据失败==>', e)
                }
              this.searchData = list

              this.isLoading = false
            },
            handleClose() {
                this.newIsCocos = false
                this.dialogVisible = false;
                this.searchValue = ''
                this.search = this.searchValue
                if (this.$refs.material) this.$refs.material.loading = false
            },
            change(html) {
                this.htmlContent = html;
            },
            close(){
                this.dialogVisible = false
                this.htmlContent = ''
                if (this.$refs.material) this.$refs.material.loading = false
            },
            handleClickChangeFilter(value){
                this.newFilterValue = value
                this.$emit('onFilterChange', value)
            },
            onFilterChange(value){
                this.gameType = value
                const enums = {
                    tools: 'tools',
                    game: 'io'
                }
                this.getSearchData({perPage: 9999, gtype: enums[this.type]})
            },
            handleSend(){
                this.$emit('onEditContent', this.htmlContent)
                this.close()
            },
            handlerClear(){
                this.newFilterValue = ''
            }
        },
    };
</script>

<style scoped>
.more-box >>> .el-dialog__body{
    padding: 0px;
}
.more-box >>> .el-dialog__header{
    border-bottom: 1px solid #f1f1f1;
}
.search{
    position: absolute;
    right: 50px;
    top: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.select-box{
    margin-right: 10px;
}
.select-box >>> .el-input__inner{
    width: 100px !important;
}
.more-box >>> .el-input.is-active .el-input__inner,
.more-box >>> .el-input__inner:focus{
    border-color: #DCDFE6 !important;
}
.search >>> .el-input__inner{width: 192px}
</style>
